import React, { Component } from 'react'
import { Button, Modal} from 'semantic-ui-react'
import {connect} from "react-redux";
import {getMedical} from '../../redux/modules/billing';

 class Medical extends Component {
     componentDidMount = () => {
         const {dispatch, selectedPT_Num,selectedPracticeName} = this.props;
         if(selectedPT_Num&&selectedPracticeName) {
             dispatch(getMedical(selectedPT_Num,selectedPracticeName));
         }
     }

    render() {
        const {allergy,medication,service,medical,MedUrgNote}=this.props.medical;

        return(
            <Modal
                trigger={<Button>Scrolling Content Modal</Button>}
                open={true}
                onClose={() => this.props.hideMedical()}
                centered={false}
                style = {{ overflow: 'auto' }}
                closeIcon
                size={ "large" }
                className={  "" }
            >
                <Modal.Header>Medical</Modal.Header>

                <Modal.Content scrolling className="pt-0">
                    <Modal.Description className="mt20">
                        {medication&&medication.length>0&&
                         <p>Medication : {medication.map(r=>r.Medications).join(" , ")}</p>}
                        {allergy&&allergy.length>0&&
                        <p>Allergy :    {allergy.map(r=>r.allergy).join(" , ")}</p>}
                        {service&&service.length>0&&
                        <p>Service :    {service.map(r=>r.Service).join(" , ")}</p>}

                        {MedUrgNote&&MedUrgNote.length>0&&
                        <p>Medical Urgent note:    {MedUrgNote.map(r=>r.MedUrgNote).join(" , ")}</p>}

                        {(!medication||medication.length==0)
                        &&(!allergy||allergy.length==0)
                        &&(!service||service.length==0)
                        &&(!MedUrgNote||MedUrgNote.length==0)&&
                            <p>No Data</p>
                        }

                    </Modal.Description>
                </Modal.Content>
                <Modal.Actions>

                </Modal.Actions>

            </Modal>
        );
    }
}
export default connect(
    state => ({
        user: state.get('auth').get('user'),
        medical: state.get('billing').get('medical'),
    }))(Medical);